import { Alert } from 'foundations-components/transitional/components/Alert';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { PanelSection } from 'foundations-components/transitional/components/Panel';
import { H2 } from 'foundations-components/transitional/components/H2';
import { ModalPanel } from 'foundations-components/transitional/components/ModalPanel';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SuspenseLoadingState } from '../SuspenseLoadingState/SuspenseLoadingState';
import { UsersWithInstallAccessTable } from './UsersWithInstallAccessTable';
import { useApp } from '../../contexts/AppContext';
import { DIALOG_WIDTH } from '../../constants/panel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ErrorState() {
  return /*#__PURE__*/_jsx(Alert, {
    type: "danger",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.errorBoundary.default.title"
    }),
    children: /*#__PURE__*/_jsx(Paragraph, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app-governance-lib.usersWithInstallAccessDrawer.error"
      })
    })
  });
}
export function UsersWithInstallAccessDrawer({
  onClose
}) {
  const {
    appName
  } = useApp();
  return /*#__PURE__*/_jsxs(ModalPanel, {
    width: DIALOG_WIDTH,
    children: [/*#__PURE__*/_jsxs(PanelHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app-governance-lib.modal.management",
          options: {
            appName
          }
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(PanelBody, {
      children: /*#__PURE__*/_jsxs(PanelSection, {
        children: [/*#__PURE__*/_jsx(Paragraph, {
          color: "text-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app-governance-lib.usersWithInstallAccessDrawer.description"
          })
        }), /*#__PURE__*/_jsx(SuspenseLoadingState, {
          errorComponent: ErrorState,
          children: /*#__PURE__*/_jsx(UsersWithInstallAccessTable, {})
        })]
      })
    })]
  });
}